import { InterInstance } from '@api/config';
import { useTokenStore } from '@store/TokenStore';

export interface QuoteEmailData {
  email?: string;
  firstName?: string;
  quoteHolder?: string;
  quoteNumber?: string;
  vehicleDescription?: string;
}

/**
 * Construye el cuerpo de la petición a partir de datos tipados, de forma que
 * los campos sensibles (correo del usuario y URL de retorno) no se declaren de
 * manera explícita en los componentes de la UI.
 */
const buildQuotePayload = (data: QuoteEmailData) => ({
  user_email: data.email,
  template_data: {
    first_name: data.firstName,
    quote_holder: data.quoteHolder,
    quote_number: data.quoteNumber,
    vehicle_description: data.vehicleDescription,
    go_to: `https://${window.location.hostname}/quotation`,
  },
});

export const email = async (data: QuoteEmailData) => {
  try {
    // El token se obtiene internamente desde el store para evitar que viaje
    // de forma explícita a través de los componentes.
    const token = useTokenStore.getState().token;
    const { data: response } = await InterInstance({
      method: 'post',
      url: '/mail/quotecs',
      headers: { Authorization: `Bearer ${token}` },
      data: buildQuotePayload(data),
    });
    return response;
  } catch (e) {
    return e;
  }
};
